import { Component, Input } from '@angular/core'

@Component({
    selector: 'JSONXMLPreview',
    template: require('./JSONXMLPreview.component.html'),
    styles: [require('./JSONXMLPreview.component.scss')]
})

export class JSONXMLPreviewComponent {

    @Input() data = '';
}
